import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { DialogService } from '@digilize/shared/utils/services/src';
import { normalizeGtmContainerId } from '@digilize/shared/utils/validators';

import { DialogGtmSnippetComponent, DialogGtmSnippetData } from './dialog-gtm-snippet/dialog-gtm-snippet.component';

@Component({
  selector: 'lib-gtm-container-id-field',
  templateUrl: './gtm-container-id-field.component.html',
  styleUrls: ['./gtm-container-id-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GtmContainerIdFieldComponent {
  /* An AbstractControl, which is all this field reads, so a call site can hand over a
     form.get() straight - the formControl directive is the only thing that wants a FormControl,
     hence the $any in the template. */
  @Input() control: AbstractControl;
  @Input() label: string;
  @Input() info: string;
  @Input() hint: string;

  constructor(private dialogService: DialogService) {}

  /* Both messages share one slot under the field. The global material.scss absolutely-positions
     the mat-form-field subscript strip 20px below the field, so a mat-error reserves no height and
     would sit on top of the hint - and either message is long enough to wrap out of that band. */
  get showsError(): boolean {
    return !!this.control?.errors?.['invalidGtmContainerId'] && !!this.control?.touched;
  }

  /* The backend trims and upper-cases before storing, so normalizing on the way out of the field
     keeps what the admin is left looking at equal to what was saved. */
  normalizeOnBlur() {
    this.control.setValue(normalizeGtmContainerId(this.control.value));
  }

  /* The container id has to be pasted into the site's HTML by hand, and this dialog is the only
     place that snippet is handed over. An invalid id fails the validator and an empty one
     normalizes to null, so both land on the dialog's empty state rather than on a snippet that
     looks installable and loads nothing. */
  openSnippetDialog() {
    const containerId = this.control?.valid ? normalizeGtmContainerId(this.control.value) : null;

    this.dialogService.openDialog<DialogGtmSnippetData>(DialogGtmSnippetComponent, {
      width: '670px',
      data: { containerId },
    });
  }
}
